import type { RouteLocationRaw, Router } from "vue-router";

import type { JobAnalysisEntry } from "@/stores/job_analysis_tracker";

const POSITION_SETUP_ROWS = [
  "position-overview",
  "phone-interview",
  "candidate-faq",
  "hiring-process",
] as const;

export type PositionSetupRow = (typeof POSITION_SETUP_ROWS)[number];

export const isPositionSetupRow = (value: unknown): value is PositionSetupRow =>
  typeof value === "string" &&
  (POSITION_SETUP_ROWS as readonly string[]).includes(value);

export const openPositionAiSetup = (
  router: Router,
  positionId: number,
  query?: { open: PositionSetupRow },
) =>
  router.push({
    name: "PositionInitialSetupEdit",
    params: { positionId },
    ...(query ? { query } : {}),
  });

// A voice entry carries its id in `previous` so the route differs from the current one and the page remounts.
export const jobAnalysisEntryPoint = (
  entry: JobAnalysisEntry,
): RouteLocationRaw => {
  switch (entry.source) {
    case "url":
      return { name: "PositionCreateManual", query: { tab: "url" } };
    case "file":
      return { name: "PositionCreateManual", query: { tab: "upload" } };
    case "voice":
      return {
        name: "PositionCreateVoice",
        query: { previous: String(entry.jobAnalysisId) },
      };
    case "ats":
      return { name: "PositionList" };
  }
};

export const openJobAnalysisEntryPoint = (
  router: Router,
  entry: JobAnalysisEntry,
) => router.push(jobAnalysisEntryPoint(entry));
